import { z } from "zod";
import { ZProjectNo } from "./foundationSchema";
export const DROFUS_ROOM_OCCURRENCES_LIVE_SELECT_FIELDS = [
    "id",
    "parent_occurrence_id",
    "quantity",
    "existing_quantity",
    "net_quantity",
    "equipment_list_type_id",
    "equipment_list_type_id_name",
    "room_id",
    "room_id_room_func_no",
    "room_id_architect_no",
    "room_id_full_name",
    "article_id",
    "article_id_number",
    "article_id_name",
    "article_id_responsibility_responsibility",
    "article_id_to_be_drawn",
    "article_id_bip",
    "occurrence_responsibility",
    "responsibility",
    "status_text",
    "name_or_item_name",
];
export const DROFUS_ROOM_OCCURRENCES_LIVE_SELECT = DROFUS_ROOM_OCCURRENCES_LIVE_SELECT_FIELDS.join(",");
export const ZDrofusRoomOccurrencesLiveRequest = z.object({
    projectNo: ZProjectNo,
    roomNumber: z.string().trim().min(1),
    maxRows: z.number().int().positive().max(1000).default(500),
    jRoomsOnly: z.boolean().default(true),
});
export const ZDrofusRoomOccurrenceLiveItem = z.object({
    occurrenceId: z.number().int().nullable(),
    quantity: z.number().nullable(),
    existingQuantity: z.number().nullable(),
    netQuantity: z.number().nullable(),
    equipmentListTypeId: z.number().nullable(),
    equipmentListTypeName: z.string().nullable(),
    roomId: z.number().nullable(),
    roomFunctionNo: z.string().nullable(),
    roomArchitectNo: z.string().nullable(),
    roomFullName: z.string().nullable(),
    articleId: z.number().nullable(),
    compCode: z.string().nullable(),
    articleName: z.string().nullable(),
    articleResponsibility: z.string().nullable(),
    articleToBeDrawn: z.boolean().nullable(),
    articleBip: z.boolean().nullable(),
    occurrenceResponsibility: z.string().nullable(),
    responsibility: z.string().nullable(),
    statusText: z.string().nullable(),
    nameOrItemName: z.string().nullable(),
    sourceValues: z.record(z.string(), z.unknown()),
});
export const ZDrofusRoomOccurrencesLiveResponse = z.object({
    ok: z.literal(true),
    projectNo: ZProjectNo,
    roomNumber: z.string(),
    fetchedAt: z.string().datetime(),
    elapsedMs: z.number().int().nonnegative(),
    fetchedRows: z.number().int().nonnegative(),
    usedParams: z.object({
        maxRows: z.number().int().positive(),
        jRoomsOnly: z.boolean(),
        filter: z.string(),
        select: z.string(),
    }),
    items: z.array(ZDrofusRoomOccurrenceLiveItem),
});
